<div @fadeIn>
    <div fxLayout="row wrap" fxLayoutAlign="space-between start" class="m-b-10">
        <div class="title">
            Dashboard
        </div>
        <div (click)="onClosePopup()" class="close-btn" fxLayoutAlign="center center">
            <mat-icon>clear</mat-icon>    
        </div>
    </div>
    <form (ngSubmit)="addDashboard()" [formGroup]="dashboardForm">
        <div class="addDashboard">
            <div fxLayout="row wrap">
                <mat-form-field appearance="outline">
                    <input matInput placeholder="Dashboard Name" formControlName="boardName">
                </mat-form-field>
            </div>
            <div fxLayout="row wrap">
                <mat-form-field appearance="outline">
                    <textarea rows="4" matInput placeholder="Dashboard Description"
                        formControlName="boardDescription"></textarea>
                </mat-form-field>
            </div>
        </div>
        <div fxLayoutAlign="start center" class="m-t-10">
            <button class="m-r-15" color="primary" type="submit" mat-raised-button>Add Dashboard</button>
        </div>
    </form>
</div>